<template>
  <div class="sign-in-page">
    <!-- ── 动态模糊背景层 ── -->
    <div class="bg-blobs" aria-hidden="true">
      <span class="blob b1"></span>
      <span class="blob b2"></span>
      <span class="blob b3"></span>
      <span class="blob b4"></span>
      <span class="blob b5"></span>
    </div>

    <!-- ── 主内容区：左右分栏 ── -->
    <div class="main-container">
      <!-- 左侧品牌宣传区 -->
      <div class="brand-section">
        <div class="brand-content">
          <!-- Logo -->
          <div class="brand-logo">
            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="24" cy="24" r="22" stroke="url(#g1)" stroke-width="2.5"/>
              <path d="M14 30 C14 20, 24 14, 34 20" stroke="url(#g2)" stroke-width="2" stroke-linecap="round"/>
              <path d="M14 28 C18 22, 30 18, 34 24" stroke="#00d4aa" stroke-width="2" stroke-linecap="round"/>
              <circle cx="24" cy="24" r="5" fill="url(#g3)"/>
              <defs>
                <linearGradient id="g1" x1="0" y1="0" x2="48" y2="48">
                  <stop offset="0%" stop-color="#2563EB"/>
                  <stop offset="100%" stop-color="#6b4fbb"/>
                </linearGradient>
                <linearGradient id="g2" x1="0" y1="0" x2="48" y2="48">
                  <stop offset="0%" stop-color="#2563EB"/>
                  <stop offset="100%" stop-color="#00d4aa"/>
                </linearGradient>
                <radialGradient id="g3" cx="50%" cy="50%" r="50%">
                  <stop offset="0%" stop-color="#fff"/>
                  <stop offset="100%" stop-color="#2563EB"/>
                </radialGradient>
              </defs>
            </svg>
            <div class="brand-title-group">
              <h1 class="brand-title">艾捷思育种系统</h1>
              <p class="brand-subtitle">畜牧智能管理平台</p>
            </div>
          </div>

          <!-- 主标题 -->
          <div class="hero-text">
            <h2 class="hero-title">数字化育种管理</h2>
            <h2 class="hero-title">开启智慧养殖新时代</h2>
          </div>

          <!-- 描述文字 -->
          <p class="hero-desc">
            通过数据驱动的决策，优化育种计划，实时追踪个体信息，提升养殖效率与收益
          </p>

          <!-- 特性列表 -->
          <div class="feature-list">
            <div class="feature-item">
              <svg viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
              </svg>
              <span>个体信息全面管理</span>
            </div>
            <div class="feature-item">
              <svg viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
              </svg>
              <span>育种计划智能优化</span>
            </div>
            <div class="feature-item">
              <svg viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
              </svg>
              <span>实时数据监控分析</span>
            </div>
          </div>
        </div>

        <!-- 版权信息 -->
        <div class="copyright">©2026 艾捷思科技 版权所有</div>
      </div>

      <!-- 右侧登录表单区 -->
      <div class="login-section">
        <div class="login-card">
          <div class="login-header">
            <h2 class="login-title">欢迎登录</h2>
            <p class="login-subtitle">请输入您的账号信息</p>
          </div>

          <!-- 登录表单 -->
          <form class="login-form" @submit.prevent="handleSubmit" autocomplete="off">
            <!-- 手机号/邮箱 -->
            <div class="form-field">
              <label>手机号 / 邮箱</label>
              <div class="input-wrapper">
                <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8 19.79 19.79 0 01.01 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14v2.92z"/>
                </svg>
                <input
                  v-model="form.mobile"
                  type="tel"
                  placeholder="请输入手机号"
                  autocomplete="username"
                />
              </div>
            </div>

            <!-- 密码 -->
            <div class="form-field">
              <label>密码</label>
              <div class="input-wrapper">
                <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0110 0v4"/>
                </svg>
                <input
                  v-model="form.user_password"
                  :type="showPassword ? 'text' : 'password'"
                  placeholder="请输入密码"
                  autocomplete="current-password"
                />
                <button type="button" class="toggle-password" @click="showPassword = !showPassword" tabindex="-1">
                  <svg v-if="showPassword" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94"/>
                    <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                  <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                </button>
              </div>
            </div>

            <!-- 验证码 -->
            <div v-if="captchaRequired" class="form-field">
              <label>验证码</label>
              <div class="captcha-row">
                <div class="input-wrapper captcha-input">
                  <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                  </svg>
                  <input
                    v-model="form.captcha_value"
                    type="text"
                    placeholder="请输入验证码"
                    maxlength="6"
                  />
                </div>
                <div
                  class="captcha-img"
                  @click="loadCaptcha"
                  :title="captchaLoading ? '加载中...' : '点击刷新'"
                >
                  <img v-if="captchaImage" :src="captchaImage" alt="验证码" />
                  <div v-else-if="captchaLoading" class="captcha-placeholder loading">
                    <span class="spin"></span>
                  </div>
                  <div v-else class="captcha-placeholder">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/>
                      <path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <!-- 记住我 -->
            <div class="remember-row">
              <label class="checkbox-wrapper">
                <input type="checkbox" v-model="form.remember" />
                <span class="checkmark"></span>
                <span class="checkbox-label">记住我</span>
              </label>
            </div>

            <!-- 错误提示 -->
            <transition name="fade">
              <div v-if="errorMsg" class="error-msg">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                {{ errorMsg }}
              </div>
            </transition>

            <!-- 登录按钮 -->
            <button type="submit" class="submit-btn" :disabled="submitting">
              <span v-if="submitting" class="btn-spinner"></span>
              <template v-else>
                <span>登录</span>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="5" y1="12" x2="19" y2="12"/>
                  <polyline points="12 5 19 12 12 19"/>
                </svg>
              </template>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignIn',
  data() {
    return {
      form: {
        mobile: '',
        user_password: '',
        captcha_value: '',
        captcha_id: '',
        remember: false,
      },
      showPassword: false,
      submitting: false,
      captchaImage: null,
      captchaLoading: false,
      errorMsg: '',
      captchaRequired: true, // 是否需要验证码
      checkingCaptcha: false, // 正在检查验证码需求
    };
  },
  watch: {
    // 监听手机号变化，检查是否需要验证码
    'form.mobile': {
      handler(newMobile) {
        // 防抖处理：手机号变化后延迟检查
        if (this.checkCaptchaTimer) {
          clearTimeout(this.checkCaptchaTimer);
        }
        // 只有当手机号有值且格式正确时才检查
        if (newMobile && /^1\d{10}$/.test(newMobile)) {
          this.checkCaptchaTimer = setTimeout(() => {
            this.checkCaptchaRequired(newMobile);
          }, 300);
        } else {
          // 手机号格式不正确时，默认显示验证码
          this.captchaRequired = true;
        }
      },
      immediate: false,
    }
  },
  mounted() {
    this.loadCaptcha();
  },
  beforeDestroy() {
    if (this.checkCaptchaTimer) {
      clearTimeout(this.checkCaptchaTimer);
    }
  },
  methods: {
    async checkCaptchaRequired(mobile) {
      this.checkingCaptcha = true;
      try {
        const res = await this.$api.check_captcha_required(mobile);
        if (res && res.code === 200) {
          this.captchaRequired = res.data.required;
          // 如果需要验证码且尚未加载，则加载验证码
          if (this.captchaRequired && !this.captchaImage) {
            this.loadCaptcha();
          }
        }
      } catch (e) {
        console.error('[check-captcha-required] failed', e);
        // 出错时默认需要验证码
        this.captchaRequired = true;
      } finally {
        this.checkingCaptcha = false;
      }
    },

    async loadCaptcha() {
      // 如果不需要验证码，则不加载
      if (!this.captchaRequired) {
        return;
      }
      this.captchaLoading = true;
      this.captchaImage = null;
      try {
        const res = await this.$api.get_captcha();
        if (res && res.code === 200) {
          this.form.captcha_id = res.data.id;
          const raw = res.data.imageBase64 || '';
          this.captchaImage = raw.startsWith('data:')
            ? raw
            : `data:image/svg+xml;base64,${raw}`;
        }
      } catch (e) {
        console.error('[captcha] load failed', e);
      } finally {
        this.captchaLoading = false;
      }
    },

    async handleSubmit() {
      this.errorMsg = '';
      if (!this.form.mobile) { this.errorMsg = '请输入手机号'; return; }
      if (!this.form.user_password) { this.errorMsg = '请输入密码'; return; }
      // 只有需要验证码时才校验验证码
      if (this.captchaRequired && !this.form.captcha_value) { this.errorMsg = '请输入验证码'; return; }

      this.submitting = true;
      try {
        await this.$store.dispatch('main/user/login', {
          mobile: this.form.mobile,
          user_password: this.form.user_password,
          captcha_id: this.captchaRequired ? this.form.captcha_id : undefined,
          captcha_value: this.captchaRequired ? this.form.captcha_value : undefined,
          remember: this.form.remember,
        });
        this.$router.replace({ path: '/dashboard' });
      } catch (e) {
        this.form.captcha_value = '';
        if (this.captchaRequired) {
          await this.loadCaptcha();
        }
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="scss">
// ─────────────────────────────────────────────
// Sign-In Page — 左右分栏布局
// Primary: #2563EB (品牌蓝)
// ─────────────────────────────────────────────

$blue: #2563EB;
$blue-light: #2563EB;
$teal: #00d4aa;
$purple: #6b4fbb;

// ── 动画关键帧 ───────────────────────────────────
@keyframes meshMorph {
  0%   { transform: translate(0%,   0%)   scale(1);    filter: hue-rotate(0deg)   brightness(1);   }
  14%  { transform: translate(4%,  -6%)   scale(1.05); filter: hue-rotate(22deg)  brightness(1.08); }
  28%  { transform: translate(-6%,  3%)   scale(0.96); filter: hue-rotate(-18deg) brightness(0.95); }
  42%  { transform: translate(7%,   7%)   scale(1.07); filter: hue-rotate(38deg)  brightness(1.05); }
  57%  { transform: translate(-4%, -8%)   scale(0.95); filter: hue-rotate(-8deg)  brightness(0.97); }
  71%  { transform: translate(5%,   4%)   scale(1.04); filter: hue-rotate(28deg)  brightness(1.06); }
  85%  { transform: translate(-7%,  2%)   scale(0.98); filter: hue-rotate(-30deg) brightness(0.93); }
  100% { transform: translate(0%,   0%)   scale(1);    filter: hue-rotate(0deg)   brightness(1);   }
}

@keyframes drift1 {
  0%   { transform: translate(0,    0)    scale(1);    }
  30%  { transform: translate(6%,   10%)  scale(1.08); }
  60%  { transform: translate(12%,  4%)   scale(0.94); }
  80%  { transform: translate(4%,   14%)  scale(1.06); }
  100% { transform: translate(0,    0)    scale(1);    }
}
@keyframes drift2 {
  0%   { transform: translate(0,    0)    scale(1);    }
  25%  { transform: translate(-8%,  7%)   scale(1.05); }
  55%  { transform: translate(-4%, -10%)  scale(0.92); }
  75%  { transform: translate(-12%, 5%)   scale(1.1);  }
  100% { transform: translate(0,    0)    scale(1);    }
}
@keyframes drift3 {
  0%   { transform: translate(0,    0)    scale(1);    }
  35%  { transform: translate(10%, -6%)   scale(1.06); }
  65%  { transform: translate(5%,   9%)   scale(0.96); }
  100% { transform: translate(0,    0)    scale(1);    }
}
@keyframes drift4 {
  0%   { transform: translate(0,    0)    scale(1);    }
  40%  { transform: translate(-5%,  -8%)  scale(1.04); }
  70%  { transform: translate(-10%, 5%)   scale(0.97); }
  100% { transform: translate(0,    0)    scale(1);    }
}
@keyframes drift5 {
  0%   { transform: translate(0,    0)    scale(1);    }
  20%  { transform: translate(7%,  -12%)  scale(1.07); }
  50%  { transform: translate(3%,   6%)   scale(0.95); }
  80%  { transform: translate(9%,  -4%)   scale(1.03); }
  100% { transform: translate(0,    0)    scale(1);    }
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-6px); }
  to   { opacity: 1; transform: translateY(0); }
}

// ── 页面容器 ─────────────────────────────────────
.sign-in-page {
  position: relative;
  min-height: 100vh;
  display: flex;
  overflow: hidden;

  // 动态背景层
  background: #050c1f;

  &::before {
    content: '';
    position: absolute;
    inset: -20%;
    width: 140%;
    height: 140%;
    z-index: 0;
    will-change: transform, filter;
    background:
      radial-gradient(ellipse 70% 55% at 28% 38%, rgba(22, 88, 220, 0.78) 0%,  transparent 60%),
      radial-gradient(ellipse 60% 70% at 75% 62%, rgba(14, 48, 160, 0.72) 0%,  transparent 58%),
      radial-gradient(ellipse 55% 50% at 52% 88%, rgba(8,  30, 115, 0.68) 0%,  transparent 55%),
      radial-gradient(ellipse 80% 40% at 10% 80%, rgba(18, 60, 180, 0.50) 0%,  transparent 60%),
      linear-gradient(160deg, #050d1e 0%, #091535 45%, #0c2050 75%, #0e2d6e 100%);
    animation: meshMorph 22s ease-in-out infinite;
  }
}

// ── 动态模糊背景 ─────────────────────────────────
.bg-blobs {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: 1;
}

.blob {
  position: absolute;
  border-radius: 50%;
  will-change: transform;
  filter: blur(72px);
}

.b1 {
  width: 55vw; height: 55vw;
  max-width: 700px; max-height: 700px;
  top: -18%; left: -12%;
  background: radial-gradient(circle, rgba(24, 100, 240, 0.55) 0%, transparent 68%);
  animation: drift1 28s ease-in-out infinite;
}

.b2 {
  width: 50vw; height: 50vw;
  max-width: 640px; max-height: 640px;
  bottom: -15%; right: -10%;
  background: radial-gradient(circle, rgba(18, 60, 160, 0.60) 0%, transparent 68%);
  animation: drift2 34s ease-in-out infinite;
  animation-delay: -8s;
}

.b3 {
  width: 42vw; height: 42vw;
  max-width: 540px; max-height: 540px;
  top: 30%; right: -8%;
  background: radial-gradient(circle, rgba(10, 70, 180, 0.50) 0%, transparent 68%);
  animation: drift3 24s ease-in-out infinite;
  animation-delay: -14s;
}

.b4 {
  width: 36vw; height: 36vw;
  max-width: 460px; max-height: 460px;
  top: -10%; right: 15%;
  background: radial-gradient(circle, rgba(8, 40, 120, 0.55) 0%, transparent 68%);
  animation: drift4 40s ease-in-out infinite;
  animation-delay: -20s;
}

.b5 {
  width: 38vw; height: 38vw;
  max-width: 480px; max-height: 480px;
  bottom: 5%; left: 10%;
  background: radial-gradient(circle, rgba(30, 90, 200, 0.45) 0%, transparent 68%);
  animation: drift5 32s ease-in-out infinite;
  animation-delay: -5s;
}

// ── 主容器：左右分栏 ─────────────────────────────
.main-container {
  position: relative;
  z-index: 10;
  display: flex;
  width: 100%;
  min-height: 100vh;
}

// ── 左侧品牌宣传区 ───────────────────────────────
.brand-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 48px 60px;
  position: relative;
  z-index: 2;

  // 半透明蓝色覆盖层
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(0, 91, 255, 0.15) 0%, rgba(0, 40, 120, 0.25) 100%);
    z-index: -1;
  }
}

.brand-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

// Logo区域
.brand-logo {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 48px;

  svg {
    width: 48px;
    height: 48px;
    flex-shrink: 0;
  }

  .brand-title-group {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .brand-title {
    font-size: 22px;
    font-weight: 700;
    color: #fff;
    margin: 0;
    letter-spacing: 1px;
  }

  .brand-subtitle {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.6);
    margin: 0;
    letter-spacing: 1px;
  }
}

// 主标题
.hero-text {
  margin-bottom: 24px;
}

.hero-title {
  font-size: 42px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 8px;
  line-height: 1.2;
  letter-spacing: 1px;
}

// 描述文字
.hero-desc {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.8;
  margin: 0 0 40px;
  max-width: 420px;
}

// 特性列表
.feature-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.feature-item {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 12px 24px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(8px);
  border-radius: 24px;
  width: fit-content;
  transition: all 0.3s ease;

  svg {
    width: 18px;
    height: 18px;
    color: $blue-light;
    flex-shrink: 0;
  }

  span {
    font-size: 14px;
    color: #fff;
    white-space: nowrap;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    transform: translateX(4px);
  }
}

// 版权信息
.copyright {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  padding-top: 24px;
}

// ── 右侧登录表单区 ───────────────────────────────
.login-section {
  width: 520px;
  min-width: 520px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background: #fff;
  position: relative;
  z-index: 2;
}

.login-card {
  width: 100%;
  max-width: 400px;
}

// 登录头部
.login-header {
  margin-bottom: 32px;
}

.login-title {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 8px;
}

.login-subtitle {
  font-size: 14px;
  color: #8c8c8c;
  margin: 0;
}

// ── 表单样式 ─────────────────────────────────────
.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 8px;

  label {
    font-size: 14px;
    font-weight: 500;
    color: #1a1a2e;
  }
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;

  .input-icon {
    position: absolute;
    left: 14px;
    width: 18px;
    height: 18px;
    color: #bfbfbf;
    pointer-events: none;
    transition: color 0.25s;
  }

  input {
    width: 100%;
    padding: 12px 14px 12px 44px;
    background: #f5f5f7;
    border: 1px solid transparent;
    border-radius: 10px;
    color: #1a1a2e;
    font-size: 14px;
    outline: none;
    transition: all 0.25s;

    &::placeholder {
      color: #bfbfbf;
    }

    &:focus {
      border-color: $blue;
      background: #fff;
      box-shadow: 0 0 0 3px rgba($blue, 0.1);
    }
  }

  &:focus-within .input-icon {
    color: $blue;
  }
}

.toggle-password {
  position: absolute;
  right: 12px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #bfbfbf;
  display: flex;
  align-items: center;
  transition: color 0.2s;

  svg {
    width: 18px;
    height: 18px;
  }

  &:hover {
    color: #8c8c8c;
  }
}

// ── 验证码行 ─────────────────────────────────────
.captcha-row {
  display: flex;
  gap: 12px;

  .captcha-input {
    flex: 1;
  }
}

.captcha-img {
  width: 110px;
  height: 46px;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #e8e8e8;
  background: #f5f5f7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s;

  &:hover {
    border-color: $blue;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
}

.captcha-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8c8c8c;
  font-size: 12px;

  svg {
    width: 18px;
    height: 18px;
  }

  &.loading .spin {
    display: block;
    width: 18px;
    height: 18px;
    border: 2px solid rgba($blue, 0.2);
    border-top-color: $blue;
    border-radius: 50%;
    animation: spin 0.7s linear infinite;
  }
}

// ── 记住我 ───────────────────────────────────────
.remember-row {
  margin-top: -4px;
}

.checkbox-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;

  input[type="checkbox"] {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;

    &:checked + .checkmark {
      background: $blue;
      border-color: $blue;

      &::after {
        opacity: 1;
        transform: rotate(45deg) scale(1);
      }
    }
  }

  .checkmark {
    width: 16px;
    height: 16px;
    border: 1.5px solid #d9d9d9;
    border-radius: 4px;
    position: relative;
    transition: all 0.2s;

    &::after {
      content: '';
      position: absolute;
      left: 5px;
      top: 2px;
      width: 4px;
      height: 8px;
      border: solid #fff;
      border-width: 0 2px 2px 0;
      opacity: 0;
      transform: rotate(45deg) scale(0);
      transition: all 0.2s;
    }
  }

  .checkbox-label {
    font-size: 14px;
    color: #595959;
  }
}

// ── 错误提示 ─────────────────────────────────────
.error-msg {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 8px;
  color: #ff4d4f;
  font-size: 13px;

  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.25s, transform 0.25s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

// ── 提交按钮 ─────────────────────────────────────
.submit-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 14px;
  margin-top: 8px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  background: $blue;
  transition: all 0.25s;

  svg {
    width: 18px;
    height: 18px;
  }

  &:hover:not(:disabled) {
    background: darken($blue, 8%);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba($blue, 0.3);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  .btn-spinner {
    display: inline-block;
    width: 18px;
    height: 18px;
    border: 2px solid rgba(255, 255, 255, 0.35);
    border-top-color: #fff;
    border-radius: 50%;
    animation: spin 0.7s linear infinite;
  }
}

// ── 响应式适配 ───────────────────────────────────
@media (max-width: 1024px) {
  .brand-section {
    padding: 40px;
  }

  .hero-title {
    font-size: 32px;
  }

  .login-section {
    width: 460px;
    min-width: 460px;
  }
}

@media (max-width: 900px) {
  .main-container {
    flex-direction: column;
  }

  .brand-section {
    padding: 32px 24px;
    min-height: auto;

    .brand-logo {
      margin-bottom: 24px;

      svg {
        width: 40px;
        height: 40px;
      }

      .brand-title {
        font-size: 18px;
      }
    }

    .hero-title {
      font-size: 28px;
    }

    .hero-desc {
      margin-bottom: 24px;
    }
  }

  .feature-list {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 12px;
  }

  .feature-item {
    padding: 10px 16px;

    span {
      font-size: 13px;
    }
  }

  .copyright {
    padding-top: 16px;
    text-align: center;
  }

  .login-section {
    width: 100%;
    min-width: auto;
    min-height: 100vh;
    padding: 32px 24px;
  }
}

@media (max-width: 480px) {
  .brand-section {
    padding: 24px 16px;

    .hero-title {
      font-size: 24px;
    }
  }

  .feature-list {
    flex-direction: column;
  }

  .login-card {
    max-width: 100%;
  }
}
</style>
